module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-223.87767b37.svg";